import { render, staticRenderFns } from "./AdminStore.vue?vue&type=template&id=163cf440&scoped=true&"
import script from "./AdminStore.vue?vue&type=script&lang=js&"
export * from "./AdminStore.vue?vue&type=script&lang=js&"
import style0 from "./AdminStore.vue?vue&type=style&index=0&id=163cf440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163cf440",
  null
  
)

export default component.exports